import * as React from 'react';
import { Button } from 'reactstrap';

import './ConfigurationUnarchive.page.scss';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationUnarchive.messages';

export interface ConfigurationUnarchiveProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel & {archived?: boolean}>;
  userData: GlobalPrivateState['userData'];
  configurationId: string;
}

export interface ConfigurationUnarchiveState {
  redirect: boolean;
}

export class ConfigurationUnarchivePartial extends React.Component<ConfigurationUnarchiveProps, ConfigurationUnarchiveState> {
  constructor(props: ConfigurationUnarchiveProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      redirect: false,
    };
  }

  componentDidUpdate (prevProps: ConfigurationUnarchiveProps) {
    const configuration = this.configuration;
    const userData = this.userData;
    const prevUserData = prevProps.userData.result;

    if ((userData && userData.updated_at) !== (prevUserData && prevUserData.updated_at)) {
      if (!this.state.redirect && userData && configuration && userData.archivedConfigurations && !userData.archivedConfigurations.includes(configuration.id)) {
        // Configuration is archived
        this.setState({
          redirect: true,
        });
      }
    }
  }

  public render() {
    return (
      <div className="page-configuration-unarchive d-flex justify-content-center align-items-center vh-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="mb-5">
                <FormattedMessage {...MESSAGES.configurationUnarchiveHeadline} />
              </h3>
              <Button
                className="btn"
                onClick={this.handleClick}
              >
                <FormattedMessage {...MESSAGES.configurationUnarchiveButton} />
              </Button>
            </div>
          </div>
        </div>
        {this.state.redirect && (
          <Redirect to={`/`} />
        )}
      </div>
    );
  }

  private get userData() {
    return this.props.userData && this.props.userData.result;
  }

  private get configuration(): ConfigurationModel & {archived: boolean} | undefined {
    return this.props.configuration && this.props.configuration.result as ConfigurationModel & {archived: boolean};
  }

  private dispatchRemove() {
    if (!this.userData || !this.configuration) {
      return;
    }

    const data = this.userData;
    data.archivedConfigurations = data.archivedConfigurations && data.archivedConfigurations.filter(id => id !== (this.configuration as any).id) || [];
    this.props.dispatch(requestAPIActions.load(
      'userData', {
        url: `/UserData/${this.userData.id}`,
        options: {
          method: 'PATCH',
          data,
        },
      },
      true,
    ));
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    this.dispatchRemove();
  }
}

export const ConfigurationUnarchive = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  userData: state.userData,
}))(ConfigurationUnarchivePartial);

export default ConfigurationUnarchive;
